import {
  Model,
  ModelData,
  ModelDataHighlighted,
} from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const setModelHighlight =
  (highlighted: ModelDataHighlighted | null) => (model: Model) => {
    setDataProperty<ModelData>(model)(
      model.modelData,
      'highlighted',
      highlighted
    );
  };
